const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGifSpinningWheel(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1287",
    d: "M3098.538 86.283a4.708 4.708 0 0 1-4.708-4.708v-8.489a4.708 4.708 0 0 1 9.417 0v8.488a4.708 4.708 0 0 1-4.709 4.709z",
    transform: "translate(-3066.538 -68.378)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1288",
    d: "M3171.329 127.506a4.708 4.708 0 0 1-3.329-8.037l5.993-5.993a4.708 4.708 0 1 1 6.658 6.659l-5.992 5.993a4.7 4.7 0 0 1-3.33 1.378z",
    transform: "translate(-3126.028 -104.098)",
    style: {
      opacity: 0.2,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1289",
    d: "M3209.954 227.06h-8.475a4.708 4.708 0 1 1 0-9.417h8.475a4.708 4.708 0 0 1 0 9.417z",
    transform: "translate(-3150.663 -190.351)",
    style: {
      opacity: 0.4,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1290",
    d: "M3177.322 305.842a4.694 4.694 0 0 1-3.329-1.379L3168 298.47a4.709 4.709 0 0 1 6.659-6.659l5.992 5.993a4.708 4.708 0 0 1-3.329 8.038z",
    transform: "translate(-3126.028 -249.84)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1291",
    d: "M3098.538 338.475a4.708 4.708 0 0 1-4.708-4.708v-8.475a4.708 4.708 0 1 1 9.417 0v8.475a4.709 4.709 0 0 1-4.709 4.708z",
    transform: "translate(-3066.538 -274.475)",
    style: {
      opacity: 0.6,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1292",
    d: "M2992.992 305.8a4.708 4.708 0 0 1-3.329-8.038l6-6a4.708 4.708 0 1 1 6.658 6.659l-6 6a4.7 4.7 0 0 1-3.329 1.379z",
    transform: "translate(-2980.285 -249.799)",
    style: {
      opacity: 0.7,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1293",
    d: "M2957.749 227.06h-8.475a4.708 4.708 0 1 1 0-9.417h8.475a4.708 4.708 0 0 1 0 9.417z",
    transform: "translate(-2944.565 -190.351)",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1294",
    d: "M2998.985 127.506a4.694 4.694 0 0 1-3.329-1.379l-5.993-5.993a4.708 4.708 0 0 1 6.659-6.659l5.992 5.993a4.708 4.708 0 0 1-3.329 8.037z",
    transform: "translate(-2980.285 -104.098)",
    style: {
      opacity: 0.85,
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifSpinningWheel);
export default __webpack_public_path__ + "static/media/gif-spinning-wheel.4d8f7bfef6f1002d671f89d2be3b92ca.svg";
export { ForwardRef as ReactComponent };